export const state = () => ({
    career_offices: null,
    search: null,
    filters: null,
    order: {
        order_by: 'name',
        order_dir: 'asc',
    },
    page: null,
});

export const mutations = {
    setCareerOffices(state: any, payload: any) {
        state.career_offices = payload;
    },

    setOrder(state: any, payload: any) {
        state.order = payload;
    },

    setSearch(state: any, payload: any) {
        state.search = payload;
    },

    setFilters(state: any, payload: any) {
        state.filters = payload;
    },

    setPage(state: any, payload: number | null) {
        state.page = payload;
    },
};

export const getters = {
    getCareerOffices: (state: any) => state.career_offices,
    getSearch: (state: any) => state.search,
    getFilters: (state: any) => state.filters,
    getOrder: (state: any) => state.order,
};

export const actions = {
    getCareerOffices(state: any, payload: any) {
        let data = {
            page: state.state.page,
            search: state.state.search,
            ...state.state.filters,
            ...state.state.order,
        };

        return new Promise((resolve, reject) => {
            this.$axios
                .get('/api/career-offices', { params: { ...data } })
                .then((res) => {
                    state.commit('setCareerOffices', res.data);
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    associateToCompany(state: any, career_office_uuid: string) {
        return new Promise((resolve, reject) => {
            this.$axios
                .post(`/api/career-offices/${career_office_uuid}/companies`)
                .then((res) => {
                    state.dispatch('updateCareerOffice', res.data);
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    disassociateCompany(state: any, career_office_uuid: string) {
        return new Promise((resolve, reject) => {
            this.$axios
                .delete(`/api/career-offices/${career_office_uuid}/companies`)
                .then((res) => {
                    state.dispatch('updateCareerOffice', res.data);
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    updateCareerOffice(state: any, updatedCareerOffice: any) {
        let careerOffices = JSON.parse(JSON.stringify(state.state.career_offices));
        const index = careerOffices.data.findIndex((i) => i.uuid === updatedCareerOffice.uuid);

        if (careerOffices.data && index !== -1) {
            careerOffices.data[index] = updatedCareerOffice;
        }

        state.commit('setCareerOffices', careerOffices);
    },

    setSearch(state: any, payload: any) {
        state.commit('setSearch', payload);
    },

    setPage(state: any, payload: number | null) {
        state.commit('setPage', payload);
    },

    setFilters(state: any, payload: any) {
        state.commit('setFilters', payload);
    },

    setOrder(state: any, payload: any) {
        state.commit('setOrder', payload);
    },
};
